@if (content) {
<h4 class="h2 m-t-3 m-t-5-s m-t-5-m"
    [class.wrap]="addWrap"
    *iCms="'title' of content"></h4>
<div class="p-t-3 overflow-hidden m-b-10"
     [class.wrap]="addWrap">
    <carousel class="_simpleCarousel"
              [slidesPerView]="'auto'"
              [spaceBetween]="12"
              [scrollbar]="{scrollable: true}"
              [freeMode]="true">
        @for(card of content.cards; track $index){
        <ng-template swiperSlide>
            <div [ngClass]="[card.background || '', card.color || 'col-1']">
                <div class="w-12 ratio-1-1 overflow-hidden">
                    <shell></shell>
                    <img class="fill"
                         [image]="card.image">
                </div>
                <div class="p-a-3 p-b-5">
                    <h4 class="h4"
                        *iCms="'title' of card"></h4>
                    <p class="h5 m-t-2"
                       *iCms="'subtitle' of card; skipEmpty: true"></p>
                    <p class="p2 m-t-2"
                       *iCms="'description' of card"></p>
                </div>
            </div>
        </ng-template>
        }
    </carousel>
</div>
}
